import React from 'react'

import { Container, Row, Col } from 'reactstrap'

import { Board  } from 'code-breaker'

export default () => (
  <div>
    <p>Echaton arbeitet seit drei Jahrzehnten als Programmierer. Über die Jahre hat er außerdem mehr als 50 Lego-Modelle entworfen.</p>
    <Container>
      <Row>
        <Col><Board /></Col>
      </Row>
    </Container>
  </div>
)
